import { Select, Button, Form } from "antd";
import { FORMS, BUTTONS } from "../common/constants";
const { Option } = Select;

const OrganistionSubscriptionForm = ({
  subscriptionList,
  handleSubmit,
  isLoading,
}) => {
  const getFormFieldRule = (field) => [
    {
      required: true,
      message: `Please Choose ${field}!`,
    },
  ];

  return (
    <Form onFinish={handleSubmit} autoComplete="off" className="mt2">
      <Form.Item
        name={FORMS.ORGANISATION_SUBSCRIPTION.FIELDS.SUBSCRIPTION.NAME}
        label={FORMS.ORGANISATION_SUBSCRIPTION.FIELDS.SUBSCRIPTION.LABEL}
        rules={getFormFieldRule(
          FORMS.ORGANISATION_SUBSCRIPTION.FIELDS.SUBSCRIPTION.LABEL
        )}
      >
        <Select
          placeholder={
            FORMS.ORGANISATION_SUBSCRIPTION.FIELDS.SUBSCRIPTION.PLACEHOLDER
          }
        >
          {subscriptionList.map((plan, index) => (
            <Option key={index} value={plan.id}>
              {plan.name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Button type="primary" htmlType="submit" loading={isLoading}>
        {BUTTONS.SUBSCRIBE}
      </Button>
    </Form>
  );
};

export default OrganistionSubscriptionForm;
